module.exports = __webpack_public_path__ + "static/alva-promenade-a83ad99452419cdf01feb0da551cba37.jpg";